import React from 'react';
import { Label } from '@/components/ui/label';

const pad = (n) => String(n).padStart(2, '0');

// Render an incoming value (local-naive "YYYY-MM-DDTHH:mm", ISO string, or Date)
// as the local datetime-local string the native input expects. Using local
// components (getHours etc.) keeps the displayed time in the user's timezone
// instead of shifting it to UTC.
const toLocalInput = (value) => {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const DateTimePicker = ({ label, value, onChange, required = false, id, className = '' }) => {
  return (
    <div className="space-y-2">
      {label && (
        <Label htmlFor={id} className="text-slate-300">
          {label} {required && '*'}
        </Label>
      )}
      <input
        id={id}
        type="datetime-local"
        value={toLocalInput(value)}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className={`w-full h-10 px-3 rounded-md border bg-slate-700 border-slate-600 text-slate-100 placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${className}`}
      />
    </div>
  );
};

export default DateTimePicker;
